import classnames from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";

import styles from "./Overlay.module.scss";

type OverlayProps = {
  backLink: string | null | undefined;
  onBackClick: (() => void) | null | undefined;
};

export default function Overlay({ backLink, onBackClick }: OverlayProps) {
  if (backLink) {
    return (
      <Link
        to={backLink}
        className={styles.overlay}
        onClick={onBackClick as any}
      />
    );
  }

  return (
    <div
      onClick={onBackClick as any}
      className={classnames(styles.overlay, {
        [styles.clickable]: !!onBackClick
      })}
    />
  );
}
